var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 51,
    viewBox: "0 0 283 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1786_15764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.056 35.8901C30.4253 35.1995 29.7474 34.5543 29.0313 33.9617L25.3628 38.3704C26.2017 39.0656 26.9641 39.8581 27.6311 40.7349L27.9342 41.1304L34.327 49.5096L39.5629 46.9087L32.2041 37.2655C31.8408 36.7898 31.4591 36.3305 31.0563 35.8904L31.056 35.8901Z",
    fill: "url(#paint0_radial_1786_15764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5116 29.3663C13.9157 29.4152 13.3227 29.4896 12.7325 29.5897L0.746582 31.608C1.18794 33.3888 1.82946 35.1493 2.68233 36.8598C2.71838 36.931 2.75444 37.002 2.7908 37.0733L13.1981 35.3188L13.6895 35.2373C14.7739 35.0553 15.8739 34.9955 16.9664 35.0606L17.3105 29.3418C16.3808 29.2863 15.4428 29.295 14.5116 29.3663Z",
    fill: "url(#paint1_radial_1786_15764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.862 25.0034C14.7743 24.8044 15.6747 24.5432 16.5515 24.2211L14.557 18.8457C13.5304 19.2263 12.4569 19.4876 11.3706 19.6236L10.8745 19.6853L0.400718 21.0208C0.058202 22.93 -0.0689207 24.8838 0.0355127 26.8425L12.0969 25.309C12.69 25.2346 13.2771 25.1317 13.862 25.0034Z",
    fill: "url(#paint2_radial_1786_15764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8003 13.9791C28.0574 13.4404 28.2902 12.8928 28.499 12.3334L32.7354 0.976281C30.8637 0.434523 28.9304 0.106616 26.9701 0L23.2892 9.86664L23.1148 10.3365C22.7313 11.3602 22.2333 12.3408 21.6304 13.2511L26.4225 16.4108C26.9384 15.6357 27.3981 14.8203 27.8003 13.9791Z",
    fill: "url(#paint3_linear_1786_15764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9162 15.6006C31.6312 16.4877 31.4118 17.3939 31.2539 18.311L36.9169 19.2777C37.1019 18.2022 37.4099 17.146 37.8326 16.1356L38.0253 15.6753L42.1063 5.96397L37.2302 2.74658L32.5335 13.9227C32.3007 14.4731 32.095 15.0325 31.9162 15.6006Z",
    fill: "url(#paint4_linear_1786_15764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.056 35.8898C30.4253 35.1993 29.7474 34.554 29.0313 33.9614L25.3628 38.3702C26.2017 39.0654 26.9641 39.8579 27.6311 40.7346L27.9342 41.1301L34.327 49.5094L39.5629 46.9085L32.2041 37.2653C31.8408 36.7895 31.4591 36.3302 31.0563 35.8901L31.056 35.8898Z",
    fill: "url(#paint5_linear_1786_15764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3522 31.3082H40.3494L40.0296 30.9204C39.3318 30.0811 38.7298 29.1603 38.2402 28.1819L33.1016 30.7444C33.5187 31.5775 33.9933 32.3818 34.5248 33.1485C34.8608 33.6413 35.221 34.1146 35.6027 34.5739L43.35 43.9186L47.0785 39.4203L40.3522 31.3082Z",
    fill: "url(#paint6_linear_1786_15764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9701 32.6858C20.6937 28.4804 20.0385 24.0636 18.1223 20.2523C17.4404 18.8874 16.5987 17.5993 15.6209 16.4228L7.87385 7.07812C6.44753 8.44058 5.20116 9.95211 4.14502 11.5737L10.8741 19.6855L11.1936 20.0735C11.8917 20.9156 12.4941 21.8392 12.9833 22.8148C13.338 23.519 13.6323 24.2523 13.862 25.0036C14.3002 26.4131 14.5203 27.8912 14.5119 29.3662C14.5082 30.1528 14.4413 30.9397 14.3071 31.7192C14.1224 32.7974 13.8144 33.854 13.3911 34.8584L13.1984 35.3187L9.11493 45.0331C10.6211 46.297 12.2585 47.375 13.9941 48.253L18.6905 37.0741C19.2807 35.6695 19.7109 34.1921 19.9701 32.6858Z",
    fill: "#FF8D25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1893 17.0329C25.4793 19.7603 29.6429 21.4001 33.9138 21.6552C35.0001 21.7178 36.0895 21.6967 37.1727 21.587C37.6128 21.5424 38.0517 21.4835 38.4887 21.4103L50.4774 19.3918L48.4329 13.9237L38.0253 15.6754L37.5314 15.76C36.4525 15.9413 35.3526 16.0008 34.2542 15.9339C33.4669 15.8871 32.6846 15.7761 31.9159 15.6007C30.4731 15.2718 29.0801 14.722 27.8001 13.9791C27.1185 13.5818 26.4689 13.1293 25.8603 12.6266C25.018 11.9286 24.2559 11.1364 23.5923 10.2649L23.289 9.86666L16.8971 1.49048C15.992 1.81839 15.0978 2.19681 14.2185 2.63443C13.328 3.07608 12.4736 3.55988 11.6611 4.08863L19.0203 13.7346C19.9468 14.9508 21.0132 16.0609 22.1893 17.0329Z",
    fill: "#FF8D25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1884 24.1544L39.1242 25.6882C37.6049 25.8825 36.1087 26.2473 34.6752 26.7754C30.662 28.2535 27.156 31.0274 24.8016 34.586C23.9583 35.8608 23.2581 37.2331 22.725 38.6635L18.4858 50.0236L24.2539 50.9996L27.9346 41.1302L28.1089 40.6603C28.4925 39.6366 28.9904 38.6563 29.5962 37.7423C30.0316 37.085 30.5199 36.4651 31.0564 35.8896C32.0634 34.8057 33.2392 33.8772 34.5251 33.1479C35.2101 32.7559 35.9268 32.4242 36.6672 32.1506C37.6944 31.7731 38.7646 31.509 39.8536 31.3699L40.3497 31.3082H40.3525L50.8232 29.9761C51.1657 28.0669 51.2928 26.1134 51.1884 24.1544Z",
    fill: "#FF8D25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4016 29.9828C95.4016 39.7967 89.1014 43.2425 81.7516 43.2425C76.8128 43.2425 72.807 41.7158 70.3183 38.7935V42.8061H63.6685V7.9126H70.3183V21.1283C72.8073 18.206 76.8128 16.6796 81.7516 16.6796C89.1017 16.6796 95.4016 20.1691 95.4016 29.9828ZM88.7126 29.9828C88.7126 24.8794 85.4848 22.917 79.5349 22.917C73.585 22.917 70.318 24.8794 70.318 29.9828C70.318 35.0424 73.5847 37.0052 79.5349 37.0052C85.4851 37.0052 88.7126 35.0424 88.7126 29.9828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.991 29.852V42.8062H121.302V39.6219C117.257 41.8466 112.785 43.2422 107.38 43.2422C100.963 43.2422 96.9575 40.9305 96.9575 35.1295C96.9575 28.4561 103.491 26.3625 110.763 26.3625C114.691 26.3625 118.308 27.0601 121.302 28.1945C121.302 23.3093 115.702 22.917 112.591 22.917C109.596 22.917 105.941 23.2223 101.235 24.7924L98.8631 19.3404C103.53 17.6392 108.119 16.6799 112.902 16.6799C122.468 16.6799 127.913 20.1257 127.991 29.852ZM121.302 32.818C118.968 31.9893 115.818 31.2476 111.579 31.2476C106.602 31.2476 103.607 32.2075 103.607 34.8245C103.607 37.5287 105.824 37.7465 109.285 37.7465C112.902 37.7465 117.879 36.4817 121.301 34.8245V32.818H121.302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.546 33.7776C136.546 36.5254 139.074 37.572 146.502 37.572C153.696 37.572 154.863 37.0486 154.863 35.0424C154.863 33.0796 153.774 32.9488 145.724 32.3819C135.652 31.7277 130.713 30.8552 130.713 24.6616C130.713 17.9448 137.713 16.6799 145.88 16.6799C154.513 16.6799 160.774 17.9448 160.774 25.0106H154.085C154.085 22.8733 151.674 22.3501 145.491 22.3501C139.191 22.3501 137.402 22.8736 137.402 24.3566C137.402 25.9704 138.607 26.232 146.502 26.8863C155.447 27.6279 161.552 27.8895 161.552 34.7374C161.552 41.978 155.719 43.2428 146.891 43.2428C138.063 43.2428 129.896 41.978 129.896 33.7779H136.546L136.546 33.7776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.995 33.6031H194.606C193.09 40.1458 187.412 43.2423 178.934 43.2423C170.223 43.2423 163.456 39.4041 163.456 29.9825C163.456 20.5609 170.028 16.6797 179.323 16.6797C188.034 16.6797 194.995 20.0381 194.995 31.7274H170.262C171 35.8272 174.5 37.1794 178.934 37.1794C183.522 37.1794 186.323 36.2199 187.995 33.6028L187.995 33.6031ZM170.495 26.9734H187.879C186.751 23.3534 183.484 22.3499 179.285 22.3499C174.735 22.3499 171.546 23.3531 170.496 26.9734H170.495Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.174 7.9126V42.8061H197.524V7.9126H204.174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.934 17.1157V42.8062H207.284V17.1157H213.934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.167 28.5872L249.089 42.8062H242.4V31.4222C242.4 25.9699 240.767 23.1349 235.284 23.1349C230.811 23.1349 225.989 25.7083 223.928 28.4124V42.8059H217.278V17.1158H223.928V21.6082C227.195 18.7296 231.706 16.6797 237.267 16.6797C243.373 16.6797 249.089 19.1219 249.167 28.5869L249.167 28.5872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276 33.6031H282.611C281.095 40.1458 275.417 43.2423 266.939 43.2423C258.228 43.2423 251.461 39.4041 251.461 29.9825C251.461 20.5609 258.033 16.6797 267.328 16.6797C276.039 16.6797 283 20.0381 283 31.7274H258.267C259.006 35.8272 262.505 37.1794 266.939 37.1794C271.528 37.1794 274.328 36.2199 276 33.6028L276 33.6031ZM258.5 26.9734H275.884C274.756 23.3534 271.489 22.3499 267.289 22.3499C262.739 22.3499 259.55 23.3531 258.501 26.9734H258.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.609 15.5412C212.764 15.5412 214.512 13.7987 214.512 11.6494C214.512 9.49999 212.764 7.75757 210.609 7.75757C208.453 7.75757 206.706 9.49999 206.706 11.6494C206.706 13.7987 208.453 15.5412 210.609 15.5412Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1786_15764",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.7858 26.073) scale(25.5333 25.4608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FC631C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FC7526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8D33"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1786_15764",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.4455 25.6223) scale(14.8873 14.8451)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC631C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9626"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1786_15764",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.4456 25.6223) scale(14.8873 14.8451)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC631C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8D33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1786_15764",
    x1: 24.2142,
    y1: 15.5907,
    x2: 27.7411,
    y2: 5.46248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC631C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8D33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1786_15764",
    x1: 34.1149,
    y1: 19.0384,
    x2: 37.6418,
    y2: 8.90982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC631C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8D33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1786_15764",
    x1: 28.3053,
    y1: 37.1974,
    x2: 34.429,
    y2: 45.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#F46225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#FA7E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802,
    stopColor: "#FD8F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1786_15764",
    x1: 36.6971,
    y1: 31.041,
    x2: 42.7188,
    y2: 38.8198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#F46225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#FA7E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802,
    stopColor: "#FD8F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9626"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1786_15764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 283,
    height: 51,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderlogo);
export default __webpack_public_path__ + "static/media/headerlogo.55331f71a4e89543fc7713968687ceb7.svg";
export { ForwardRef as ReactComponent };